import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from '../../auth';
import { Loading } from '@screens/loading';

interface PrivateRouteProps {
    children: ReactElement;
}

export const PrivateRoute = ({ children }: PrivateRouteProps): ReactElement => {
    const { isAuthenticated, isLoading } = useAuthState();
    const location = useLocation();

    if (isLoading) {
        return <Loading />;
    }
    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
};
